import { getPlayerCommandList } from "./playerCommandsMapping";

export const speechCommandsES = {
    player: getPlayerCommandList('es')
}